module.exports = __webpack_public_path__ + "img/marker_line.01f5d1e6.png";